/* eslint-disable no-eval */
/* eslint-disable consistent-return */
import { getPrcCookieValue } from 'utils/primeUtil';
import Cookie, { getCookie } from '../../utils/cookies';

export async function alertLogger(calledFrom = '', extraData = {}) {
  try {
    const _gaCookie = getCookie('_ga');
    let isPrivateMode = false;
    const detectIncognito = async () =>
      new Promise((resolve, reject) => {
        let browserName = 'Unknown';
        const __callback = isPrivate => {
          resolve({
            isPrivate,
            browserName,
          });
        };
        const identifyChromium = () => {
          const ua = navigator.userAgent;
          if (ua.match(/Chrome/)) {
            if (navigator.brave !== undefined) {
              return 'Brave';
            } else if (ua.match(/Edg/)) {
              return 'Edge';
            } else if (ua.match(/OPR/)) {
              return 'Opera';
            }
            return 'Chrome';
          }

          return 'Chromium';
        };
        const assertEvalToString = value => value === eval.toString().length;
        const isSafari = () => {
          const v = navigator.vendor;
          return (
            v !== undefined &&
            v.indexOf('Apple') === 0 &&
            assertEvalToString(37)
          );
        };
        const isChrome = () => {
          const v = navigator.vendor;
          return (
            v !== undefined &&
            v.indexOf('Google') === 0 &&
            assertEvalToString(33)
          );
        };
        const isFirefox = () =>
          document.documentElement !== undefined &&
          document.documentElement.style.MozAppearance !== undefined &&
          assertEvalToString(37);
        const isMSIE = () =>
          navigator.msSaveBlob !== undefined && assertEvalToString(39);
        /**
         * Safari (Safari for iOS & macOS)
         **/
        // eslint-disable-next-line consistent-return
        const newSafariTest = () => {
          const tmpName = String(Math.random());
          try {
            const db = window.indexedDB.open(tmpName, 1);
            db.onupgradeneeded = i => {
              let _b;
              const _a = i.target;
              const res =
                _a === null || _a === undefined ? undefined : _a.result;
              try {
                res
                  .createObjectStore('test', {
                    autoIncrement: true,
                  })
                  .put(new Blob());
                __callback(false);
              } catch (e) {
                let message = e;
                _b = e.message;
                if (e instanceof Error) {
                  message = _b !== null && _b !== undefined ? _b : e;
                }
                if (typeof message !== 'string') {
                  return __callback(false);
                }
                const matchesExpectedError = /BlobURLs are not yet supported/.test(
                  message,
                );
                return __callback(matchesExpectedError);
              } finally {
                res.close();
                window.indexedDB.deleteDatabase(tmpName);
              }
            };
          } catch (e) {
            return __callback(false);
          }
        };
        const oldSafariTest = () => {
          const openDB = window.openDatabase;
          const storage = window.localStorage;
          try {
            openDB(null, null, null, null);
          } catch (e) {
            return __callback(true);
          }
          try {
            storage.setItem('test', '1');
            storage.removeItem('test');
          } catch (e) {
            return __callback(true);
          }
          return __callback(false);
        };
        const safariPrivateTest = () => {
          if (navigator.maxTouchPoints !== undefined) {
            newSafariTest();
          } else {
            oldSafariTest();
          }
        };
        /**
         * Chrome
         **/
        const getQuotaLimit = () => {
          const w = window;
          if (
            w.performance !== undefined &&
            w.performance.memory !== undefined &&
            w.performance.memory.jsHeapSizeLimit !== undefined
          ) {
            return performance.memory.jsHeapSizeLimit;
          }
          return 1073741824;
        };
        // >= 76
        const storageQuotaChromePrivateTest = () => {
          navigator.webkitTemporaryStorage.queryUsageAndQuota(
            (usage, quota) => {
              __callback(quota < getQuotaLimit());
            },
            e => {
              reject(
                new Error(
                  `detectIncognito somehow failed to query storage quota: ${
                    e.message
                  }`,
                ),
              );
            },
          );
        };
        // 50 to 75
        const oldChromePrivateTest = () => {
          const fs = window.webkitRequestFileSystem;
          const success = () => {
            __callback(false);
          };
          const error = () => {
            __callback(true);
          };
          fs(0, 1, success, error);
        };
        const chromePrivateTest = () => {
          if (
            self.Promise !== undefined &&
            self.Promise.allSettled !== undefined
          ) {
            storageQuotaChromePrivateTest();
          } else {
            oldChromePrivateTest();
          }
        };
        /**
         * Firefox
         **/
        const firefoxPrivateTest = () => {
          __callback(navigator.serviceWorker === undefined);
        };
        /**
         * MSIE
         **/
        const msiePrivateTest = () => {
          __callback(window.indexedDB === undefined);
        };
        const main = () => {
          if (isSafari()) {
            browserName = 'Safari';
            safariPrivateTest();
          } else if (isChrome()) {
            browserName = identifyChromium();
            chromePrivateTest();
          } else if (isFirefox()) {
            browserName = 'Firefox';
            firefoxPrivateTest();
          } else if (isMSIE()) {
            browserName = 'Internet Explorer';
            msiePrivateTest();
          } else {
            reject(new Error('detectIncognito cannot determine the browser'));
          }
        };
        main();
      });

    const incognitoDetails = await detectIncognito();
    isPrivateMode = incognitoDetails?.isPrivate;
    const browserName = incognitoDetails?.browserName;
    // let nudgeClickInfo;
    // if (
    //   typeof window !== 'undefined' &&
    //   window.localStorage &&
    //   localStorage.getItem('nudgeClickInfo')
    // ) {
    //   nudgeClickInfo = JSON.parse(localStorage.getItem('nudgeClickInfo'));
    // }
    let alertMsg = `
    Referrer URL is ${document?.referrer},
    Network is ${navigator?.connection?.effectiveType},
    Network Speed is ${navigator?.connection?.downlink} Mb/s,
    Current URL is ${window?.location?.href},
    UserAgent is ${navigator?.userAgent},
    isGA loaded -  ${typeof ga === 'function'},
    Geo Location is ${JSON.stringify(window?.geoinfo)},
    geo country cookie  - ${getCookie('geo_country')},
    isPrivateMode - ${isPrivateMode},
    Browser Name - ${browserName}
    `;

    switch (calledFrom) {
      case 'planpage':
        alertMsg = `${alertMsg} `;
        break;
      case 'processOrder_Log':
        alertMsg = `${alertMsg} \n Process Order ::
        _ga cookie is ${_gaCookie},\n
        Local Storage ::\n
        isLocalStorageObject - ${typeof localStorage !== 'undefined'}
        Initiation page is ${extraData?.nudgeClickInfo?.initiationPage},
        Nudge Name is ${extraData?.nudgeClickInfo?.nudgeName},
        Subscription Type is ${extraData?.options?.orderType},

        \n -------- If initiation page is story page then -------- \n
        story title is ${
          extraData?.nudgeClickInfo?.storyTitle
        } (required for every payment from story page), \n
        isPayperStory : ${extraData?.options?.orderType === 'PAY_PER_ARTICLE'}
        if payperstory true, nudgeClickInfo msid is ${
          extraData?.nudgeClickInfo?.initiateMsId
        },
        options msid is ${extraData?.options?.initiateMsId}
        `;
        break;
      case 'postProcessOrder_Log':
        alertMsg = `${alertMsg} \n
        category : PostPaymentDetails,
        msid : ${extraData?.msid}
        storyTitle: ${extraData?.storyTitle}
        prc: ${extraData?.prc}
        oldPrc: ${extraData?.oldPRC}
        popUpScreenType: ${extraData?.screenType}
        accessType: ${extraData?.planAccessType}
        nudgeClickInfo: {
          msid: ${extraData?.clickNudgeInfoValue?.msid},
          storyTitle: ${extraData?.clickNudgeInfoValue?.storyTitle}, 
        }\n
        `;
        break;
      default:
        alertMsg = `${alertMsg} `;
    }

    const ChatAPIKey =
      'AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0KWNHsfirvee1-OC50ThL-P6j2NlA9bADG3w1P_zsWU%3D';
    const url = `https://chat.googleapis.com/v1/spaces/AAAAdzvHYZ0/messages?key=${ChatAPIKey}`;
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: alertMsg,
      }),
    };
    const resp = await fetch(url, fetchConfig);
    if (resp.status !== 200) throw new Error(resp.statusText);
  } catch (e) {
    console.log('error in api response', e);
  }
}

export async function epaperAlertLogger(data = {}) {
  try {
    const prcCookie = getPrcCookieValue();
    const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    const ticketId =
      Cookie.get('ticketId') ||
      Cookie.get('ticketid') ||
      Cookie.get('TicketId');
    const alertMsg = `
        Date: ${new Date()} 
        Current Page URL : ${window.location.href},
        User Logged In Status : ${data.userData?.isLoggedIn},
        Is Prime User Akamai : ${data.isUserPrime},
        Prc In cookie: ${prcCookie},
        Ssoid in Cookie: ${ssoid},
        ticketId in Cookie: ${ticketId},
        User data ssoId: ${data.userPrcData?.ssoId},
        User data email: ${data.userPrcData?.email},
        User data mobile: ${data.userPrcData?.mobile},
        User data ticketId: ${data.userPrcData?.ticketId},
        User data planStatus: ${data.userPrcData?.planStatus},
        User data accessibleFeatures: ${data.userPrcData?.accessibleFeatures?.join(
          ',',
        )},
        Is IOS New Build: ${typeof window !== 'undefined' &&
          typeof window.webkit !== 'undefined' &&
          typeof window.webkit.messageHandlers !== 'undefined' &&
          typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined'}
        Is Android New Build: ${typeof window !== 'undefined' &&
          typeof window.tilAppWebBridge !== 'undefined'}
        UserAgent is ${navigator?.userAgent},
        Login Result: ${data.LoginType},
        jssoCrossWalkResponse: ${data.jssoCrossWalkResponse},
        invokeAfterIsAppReadySuccessCatchError : ${
          data.appReadySuccessCatchError
        }
        isAppReady: ${data.isAppReady}
        \n`;
    const ChatAPIKey =
      'AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0KWNHsfirvee1-OC50ThL-P6j2NlA9bADG3w1P_zsWU%3D';
    const url = `https://chat.googleapis.com/v1/spaces/AAAAdzvHYZ0/messages?key=${ChatAPIKey}`;
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: alertMsg,
      }),
    };
    const resp = await fetch(url, fetchConfig);
    if (resp.status !== 200) throw new Error(resp.statusText);
  } catch (e) {
    console.log('error in api response', e);
  }
}

export function isAppView() {
  const params = new URLSearchParams(document.location.search);
  const isFrmApp = params.get('frmapp') === 'yes'; // is the string "Jonathan"
  return isFrmApp;
}

export async function sendGroupChat(data = {}) {
  if (window.epaperAlertLoggerData.length > 0 && isAppView()) {
    const ChatAPIKey =
      'AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0KWNHsfirvee1-OC50ThL-P6j2NlA9bADG3w1P_zsWU%3D';
    const url = `https://chat.googleapis.com/v1/spaces/AAAAdzvHYZ0/messages?key=${ChatAPIKey}`;
    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text:
          Object.keys(data).length > 0
            ? JSON.stringify(data)
            : JSON.stringify(Object.assign({}, window.epaperAlertLoggerData)),
      }),
    };
    const resp = await fetch(url, fetchConfig);
    if (resp.status !== 200) throw new Error(resp.statusText);
  }
}

function pushEpaperAlertLogger(data = {}) {
  //const basicInfoJson = JSON.stringify(data);
  if (data && isAppView()) {
    window.epaperAlertLoggerData.push(data);
  }
}

export async function setEpaperAlertLogger(data = {}) {
  const basicInfo = {
    prcCookie: getPrcCookieValue(),
    ssoid: Cookie.get('ssoid') || Cookie.get('ssoId'),
    device_userAgent: navigator?.userAgent,
    IsIOSNewBuild:
      typeof window !== 'undefined' &&
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      typeof window.webkit.messageHandlers.tilAppWebBridge !== 'undefined',
    IsAndroidNewBuild:
      typeof window !== 'undefined' &&
      typeof window.tilAppWebBridge !== 'undefined',
    url: window.location.href,
  };
  if (data?.sendData === true) {
    if (data?.fnType === 'SecTksecValidator') {
      sendGroupChat({
        SecTksecValidator: { ...data, basicInfo },
      });
    } else {
      sendGroupChat();
    }
  } else {
    const getfnType = data.fnType;
    switch (getfnType) {
      case 'setCookiesAndGetUserInfo':
        pushEpaperAlertLogger({
          setCookiesAndGetUserInfo: { ...data, basicInfo },
        });
        break;
      case 'setCookiesAndGetUserInfoAppUserObj':
        pushEpaperAlertLogger({
          setCookiesAndGetUserInfoAppUserObj: { ...data, basicInfo },
        });
        break;
      case 'DidupdateData':
        pushEpaperAlertLogger({
          DidupdateData: { ...data, basicInfo },
        });
        break;
      case 'getTicketForApp':
        pushEpaperAlertLogger({ getTicketForApp: { ...data, basicInfo } });
        break;
      case 'getTicketCallback':
        pushEpaperAlertLogger({ getTicketCallback: { ...data, basicInfo } });
        break;
      case 'getCrsossWalkLogginUserForApp':
        pushEpaperAlertLogger({
          getCrsossWalkLogginUserForApp: { ...data, basicInfo },
        });
        break;
      case 'getValidAppLoggedInUser':
        pushEpaperAlertLogger({
          getValidAppLoggedInUser: { ...data, basicInfo },
        });
        break;
      case 'userPrcData':
        pushEpaperAlertLogger({
          userPrcData: { ...data, basicInfo },
        });
        break;

      case 'alreadyLoggedInPrcCallback':
        pushEpaperAlertLogger({
          alreadyLoggedInPrcCallback: { ...data, basicInfo },
        });
        break;

      case 'printMsg':
        pushEpaperAlertLogger({ printMsg: { ...data, basicInfo } });
        break;
      case 'endoffunction':
        pushEpaperAlertLogger({ endoffunction: { ...data, basicInfo } });
        sendGroupChat();
        break;

      default:
        break;
    }
  }
}

export async function axiosSendGroupChat(data = {}) {
  if (Object.keys(data).length > 0) {
    const ChatAPIKey =
      'AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0KWNHsfirvee1-OC50ThL-P6j2NlA9bADG3w1P_zsWU%3D';
    const url = `https://chat.googleapis.com/v1/spaces/AAAAdzvHYZ0/messages?key=${ChatAPIKey}`;
    // const config = {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // };
    // const sendJsonStringifyDataToChat = data;

    const fetchConfig = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: JSON.stringify(data),
      }),
      // body: sendJsonStringifyDataToChat,
    };
    await fetch(url, fetchConfig).catch(error => {
      console.log('sendJsonStringifyDataToChat error', error);
    });
  }
}
